<!-- Breadcrumb Component Template -->
<nav class="breadcrumb-container">
  <ol class="breadcrumb">
    <!-- <li>
      <span class="material-symbols-outlined">
        home
      </span>
    </li> -->
    <ng-container *ngFor="let breadcrumb of breadcrumbs; let last = last">
      <li *ngIf="last; else linkItem">
        <span>{{ breadcrumb.label }}</span>
      </li>
      <ng-template #linkItem>
        <li>
          <a [routerLink]="breadcrumb.url" routerLinkActive="router-link-active">{{ breadcrumb.label }}</a>
          &nbsp;
        </li>
      </ng-template>
    </ng-container>
  </ol>
</nav>



